import type { RuleRecord } from "./ruleBlocksData";

const object = (value: unknown): RuleRecord => value && typeof value === "object" && !Array.isArray(value) ? value as RuleRecord : {};
const text = (value: unknown): string => typeof value === "string" || typeof value === "number" || typeof value === "boolean" ? String(value) : "";

export const ruleComparisonSymbols: Record<string, string> = { equals: "=", not_equals: "≠", greater_than: ">", less_than: "<" };

/** Copy only displayed values: parser metadata can be large and contains no rule semantics. */
export const readRulePreview = (row: RuleRecord) => ({
	name: text(row.name),
	action: text(row.action),
	enabled: typeof row.enabled === "boolean" ? row.enabled : null,
	join: text(row.join),
	conditions: (Array.isArray(row.scope) ? row.scope : []).map(item => {
		const scope = object(item), period = object(scope.period), aggregate = object(scope.agregator), matching = object(scope.matching);
		return {
			period: { type: text(period.type), from: text(period.from), to: text(period.to) },
			metric: text(aggregate.type), amountField: text(aggregate.field), comparator: text(aggregate.comparator), threshold: text(aggregate.value),
			join: text(matching.join),
			filters: (Array.isArray(matching.fields) ? matching.fields : []).map(item => {
				const filter = object(item), against = object(filter.against);
				const declineCodes = filter.field === "fail_code" && Array.isArray(filter.fail_code);
				// An empty current list must not resurrect an obsolete scalar value.
				const values: unknown[] = declineCodes ? filter.fail_code as unknown[] : Array.isArray(against.values) ? against.values : against.value !== undefined ? [against.value] : [];
				return {
					operator: text(filter.operator) || "in",
					field: text(filter.field), source: declineCodes ? "constant" : text(against.source), paymentField: text(against.field),
					values: values.map(value => {
						const entry = object(value);
						return { value: text(typeof value === "object" ? entry.value : value), label: text(entry.name) };
					}),
				};
			}),
		};
	}),
});

export type RulePreview = ReturnType<typeof readRulePreview>;

export const ruleFilterSymbol = (operator: string): string => ({ in: "∈", not_in: "∉", ...ruleComparisonSymbols } as Record<string, string>)[operator] ?? operator;
export const isPositiveRuleFilter = (filter: { operator: string }) => ["in", "equals"].includes(filter.operator);
